import React from 'react'
import { ExportButton } from 'core/table/components'
import format from 'civic-champs-shared/utils/format'

const filename = 'roles.csv'
const headers = [
  { label: 'Name', key: 'name' },
  { label: 'Created On', key: 'createdAt' },
  { label: 'Created By', key: 'createdBy' },
  { label: 'Status', key: 'status' },
]

const formatData = (roles: any[]) =>
  roles.map(({ name, createdAt, createdBy, status }) => ({
    name,
    createdAt: format.datetime(createdAt),
    createdBy: format.name(createdBy),
    status,
  }))

export const ExportRolesButton = ({ data, disabled }: { data: any[]; disabled?: boolean }) => (
  <ExportButton data={data} disabled={disabled} formatData={formatData} headers={headers} filename={filename} />
)

export default ExportRolesButton
